import React from "react";
import TextSetting from "../TextSetting";
import locale from "../../../../../../locale";
import { defaultParticipationSelectSubtitle } from "../../../constants/loginAndRegistrationPage";

const ScreenParticipationTypeSelect = ({moduleSettings, onUpdate}) => {
    return (
        <>
            <TextSetting
                eventSetting={moduleSettings}
                title={locale('settings.subtitle')}
                property="participationTypeSubtitle"
                defaultText={defaultParticipationSelectSubtitle}
                toggleProperty="hideParticipationTypeSubtitle"
                rows={6}
                onUpdate={onUpdate}
            />
        </>
    );
};

export default ScreenParticipationTypeSelect;
